import { FacetProfileField } from '../../core/profiles/entities/profile-field.entity';
import { ShFacet, ShSelectableFacetValue } from '../../elements/components/facet/entities/facet.entity';
import { FacetSelectionType } from '../entities/facet-request.entity';
import { Facet } from '../entities/facet.entity';

export function FacetsResponseToShFacets(facets: Facet[], facetProfileFields: FacetProfileField[]): ShFacet[] {
    return facetProfileFields
        .map(facetProfileField => MapFacetToShFacet(facets, facetProfileField))
        .filter((facet): facet is ShFacet => facet !== null);
}

export function FacetResponseToShFacet(facet: Facet, label: string, selectionType: FacetSelectionType): ShFacet {
    return {
        key: facet.DottedKey,
        label,
        hasMoreValues: facet.HasMoreValues,
        values: MapValuesToShFacetValue(facet, selectionType),
        selectionType
    };
}

function MapFacetToShFacet(facets: Facet[], facetProfileField: FacetProfileField): ShFacet | null {
    const profileFacet: Facet | undefined = facets.find(facet => facet.DottedKey === facetProfileField.DottedKey);

    if (!profileFacet) {
        return null;
    }

    return FacetResponseToShFacet(profileFacet, facetProfileField.DisplayLabel, facetProfileField.SelectionType);
}

function MapValuesToShFacetValue(facet: Facet, selectionType: FacetSelectionType): ShSelectableFacetValue[] {
    return facet.Values.map(value => {
        return {
            value: value.Value,
            label: value.Value,
            selectionType,
            count: value.Count,
            missing: value.Missing,
            selected: false
        };
    });
}
